export const createOptionsFromEnum = ({ values, prefix }) => values.map((e) => ({
  value: e,
  label: `${prefix ? `${prefix}.` : ''}${e}`,
}))
